var path = '/modules/contacts/views/pages/changelog.tpl.html';
var html = "<al-entity-change-log entity=\"'contact'\"></al-entity-change-log>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/contacts/views/pages/changelog.tpl.html
// module id = 2070
// module chunks = 1